module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.674f50d2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/styles/fonts/fontawesome-webfont.eot
// module id = 2150
// module chunks = 27